import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=b7c44d46&"
import script from "./Textarea.vue?vue&type=script&lang=ts&"
export * from "./Textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports